<template lang='pug'>
div(style="width:100%; min-height:1.5rem;" @click='focus')
  b-spinner(v-if='state === "in-progress"' small style='color: #ccc')
  div(v-if='state === "display"' @drag='focus' style='user-select: none') {{ theValue }}
  div(v-if='state === "edit"' @focusout='blur' @keydown.enter='blur' @keydown.escape='escape' ref='editor')
    slot
</template>

<script>
export default {
  props: {
    commit: Function,
    theValue: String
  },

  data() {
    return {
      state: 'display' // display | edit | in-progress
    }
  },

  methods: {
    focus() {
      this.state = 'edit'
    },

    async blur() {
      this.state = 'in-progress'
      const child = this.$refs.editor.firstChild
      const value = child ? child.value : this.theValue
      await this.commit(value)
      this.state = 'display'
    },

    escape() {
      this.state = 'display'
    }
  },

  updated() {
    // Focus on the editor component
    const child = this.$refs.editor.firstChild
    if (child) {
      child.focus()
    }
  }
}
</script>
